import { threads, ranks, rankTexts } from "@/mocks/home";
import SectionHead from "./SectionHead";

const hotTone: Record<string, string> = {
  已爆: "bg-primary-500/15 text-primary-300 border-primary-500/30",
  热议: "bg-secondary-500/15 text-secondary-300 border-secondary-500/30",
  持续: "bg-accent-500/15 text-accent-300 border-accent-500/30",
  待解: "bg-background-800 text-foreground-400 border-background-600",
};

const chipTone: Record<string, string> = {
  背后真相: "text-primary-300",
  未解之谜: "text-accent-300",
  深扒中: "text-secondary-300",
};

export default function Talk() {
  return (
    <section id="talk" className="relative bg-background-900 py-20 md:py-28">
      <div className="mx-auto max-w-[1280px] px-4 md:px-6">
        <SectionHead
          kicker="社区热聊"
          title="真相需要讨论，也需要你来求证"
          desc="每篇深扒都对应一场公开讨论。带着证据进来，理性交锋；空口断案，会被大家礼貌请出。"
        />

        <div className="grid grid-cols-1 gap-8 lg:grid-cols-[1.7fr_1fr]">
          {/* 左：讨论帖列表 */}
          <div className="space-y-3">
            {threads.map((t) => {
              const tone = hotTone[t.hot] ?? hotTone.待解;
              return (
                <article
                  key={t.id}
                  className="flex cursor-pointer flex-col gap-4 rounded-xl border border-background-800 bg-background-950/70 p-5 transition-colors hover:border-background-600 sm:flex-row sm:items-center"
                >
                  <div className="flex-1">
                    <div className="mb-2 flex flex-wrap items-center gap-2">
                      <span className={`rounded-md border px-2 py-0.5 text-[11px] ${tone}`}>{t.hot}</span>
                      <span className="text-[11px] text-foreground-500">板块 · {t.tag}</span>
                    </div>
                    <h3 className="font-heading text-base font-bold leading-snug text-foreground-50">{t.title}</h3>
                    <div className="mt-3 flex flex-wrap items-center gap-x-4 gap-y-2 text-xs text-foreground-500">
                      <span className="flex items-center gap-1">
                        <i className="ri-eye-line"></i> {t.views}
                      </span>
                      <span className="flex items-center gap-1">
                        <i className="ri-chat-3-line"></i> {t.replies} 回复
                      </span>
                      <span className="flex items-center gap-1">
                        <i className="ri-time-line"></i> {t.last}
                      </span>
                    </div>
                  </div>

                  <div className="flex items-center gap-3 sm:flex-col sm:items-end">
                    <div className="flex -space-x-2">
                      {t.users.map((u, i) => (
                        <span
                          key={i}
                          className="flex h-8 w-8 items-center justify-center rounded-full border-2 border-background-950 bg-background-800 text-xs font-medium text-foreground-300"
                        >
                          {u}
                        </span>
                      ))}
                    </div>
                    <span className="flex items-center gap-1 whitespace-nowrap text-xs font-medium text-accent-300">
                      参与讨论 <i className="ri-arrow-right-line"></i>
                    </span>
                  </div>
                </article>
              );
            })}
          </div>

          {/* 右：吃瓜榜 */}
          <div id="rank" className="scroll-mt-24 rounded-2xl border border-background-800 bg-background-950/70 p-6 md:p-7">
            <div className="mb-6 flex items-center justify-between">
              <h3 className="font-heading flex items-center gap-2 text-lg font-bold text-foreground-50">
                <i className="ri-fire-fill text-primary-400"></i> 今日吃瓜榜
              </h3>
              <span className="rounded-full bg-background-800 px-2.5 py-1 text-[11px] text-foreground-400">每 10 分钟更新</span>
            </div>

            <ol className="divide-y divide-background-800">
              {ranks.map((r, idx) => {
                const tone = chipTone[r.chip] ?? "text-foreground-400";
                return (
                  <li key={r.id} className="flex cursor-pointer items-center gap-4 py-3 first:pt-0 last:pb-0 hover:bg-transparent">
                    <span
                      className={`font-heading w-8 shrink-0 text-center text-lg font-bold ${
                        idx < 3 ? "text-primary-400" : "text-foreground-600"
                      }`}
                    >
                      {rankTexts[idx]}
                    </span>
                    <div className="min-w-0 flex-1">
                      <p className="truncate text-sm font-medium text-foreground-200">{r.title}</p>
                      <span className={`mt-1 block text-[11px] ${tone}`}>{r.chip}</span>
                    </div>
                    <div className="flex shrink-0 items-center gap-1 text-xs">
                      <span className="font-heading font-semibold text-foreground-400">{r.heat}</span>
                      <i
                        className={`text-base ${
                          r.delta === "up"
                            ? "ri-arrow-up-line text-accent-400"
                            : r.delta === "down"
                              ? "ri-arrow-down-line text-primary-400"
                              : "ri-arrow-right-line text-foreground-600"
                        }`}
                      ></i>
                    </div>
                  </li>
                );
              })}
            </ol>
          </div>
        </div>
      </div>
    </section>
  );
}